export default __webpack_public_path__ + "static/pyatorochkaRed-b35c01464f75366716e19dc9231b0d9d.png";